import { render, staticRenderFns } from "./Transflow.vue?vue&type=template&id=6bf8cc18&scoped=true&"
import script from "./Transflow.vue?vue&type=script&lang=js&"
export * from "./Transflow.vue?vue&type=script&lang=js&"
import style0 from "./Transflow.vue?vue&type=style&index=0&id=6bf8cc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8cc18",
  null
  
)

export default component.exports